import { AstrologyCard } from "../../../Astrology/components";
import { HoroscopeListContainer } from "./style";

export const HoroscopeList = ({ zodiac }) => {
  function withoutTilde(sign) {
    if (sign == "Cáncer") {
      sign = "Cancer";
    } else if (sign == "Géminis") {
      sign = "Geminis";
    } else if (sign == "Búfalo") {
      sign = "Bufalo";
    } else if (sign == "Dragón") {
      sign = "Dragon";
    }
    return sign.toLowerCase();
  }

  return (
    <HoroscopeListContainer>
      <div className="horoscope-list-header">
        <h2 className="horoscope-list-header-text">Horóscopo diario</h2>
      </div>
      <AstrologyCard zodiac={zodiac} isChineseLanding={false} />
    </HoroscopeListContainer>
  );
};

// Reutilizar esto en compatibilidad de signos

/*<HoroscopeListContainer>


      <div className="horoscope-list-signs-container">
        {zodiac.length > 0 &&
          zodiac.map((element, index) => {
            let url = element.isChinese
              ? `/horoscopo-chino/caracteristicas-${withoutTilde(element.sign)}`
              : `/horoscopo/signos-zodiaco-${withoutTilde(element.sign)}`;
            return (
              <div
                className="horoscope-list-item"
                style={{ position: "relative" }}
                key={`${element.sign}-${index}`}
              >
                <figure className="horoscope-list-item-image">
                  <img
                    width="50px"
                    height="50px"
                    loading="lazy"
                    alt={`element.sign`}
                    src={`/img/westernastrology/${withoutTilde(
                      element.sign
                    )}.svg`}
                  />
                </figure>                
                <h3 className="horoscope-list-item-name">{element.sign}</h3>
                <li><a href={url} target="_self" aria-label={withoutTilde(element.sign)} className="astrology-today">Hoy</a></li>
                <li><a href={url+"/horoscopo-manana"} target="_self" aria-label={withoutTilde(element.sign)} className="astrology-tomorrow">Mañana</a></li>
              </div>
            )
          })}
      </div>
    </HoroscopeListContainer>*/
